import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
export var convertImgToBase64 = function convertImgToBase64(url) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {// axios.get(url, { responseType: 'arraybuffer'}).then((res: any) => {
                //     const result = 'data:image/png;base64,' + btoa(
                //         new Uint8Array(res.data)
                //             .reduce((data, byte) => data + String.fromCharCode(byte), '')
                //     );
                //     resolve(result)
                // });
              } catch (e) {}

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
export var canvasDrawNetImage = function canvasDrawNetImage(url) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var image;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                image = new Image();
                image.src = url + '?v=' + new Date().getTime(); // 处理缓存

                console.log('image.src', image.src);
                image.crossOrigin = "*"; // 支持跨域图片

                image.onload = function () {
                  var base64 = getBase64Image(image);
                  resolve(base64);
                };
              } catch (e) {
                reject(e);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};
export var getBase64Image = function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var dataURL = canvas.toDataURL("image/png"); // 可选其他值 image/jpeg

  return dataURL;
};